<template>
  <!-- Modal terms -->
  <div class="modal fade" id="redirect-modal" tabindex="-1" role="dialog" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered modal-lg">
      <div class="modal-content p-3 p-md-4">
        <div class="header">
          <div class="header-main">
            <img loading="lazy" src="/img/logo/logomark-black.png" alt="Workhy" />
            <p class="header-text">
              <span v-if="redirectedCountry">
                {{
                  $t('redirectModal.headerText', {
                    country: getMultiLangName(redirectedCountry, redirectedCountry.country_name),
                  })
                }}
              </span>
            </p>
          </div>
          <button type="button" class="close-button align-self-start close" data-dismiss="modal" aria-label="Close">
            <svg
              xmlns="http://www.w3.org/2000/svg"
              fill="none"
              viewBox="0 0 24 24"
              stroke-width="1.5"
              stroke="currentColor"
              style="height: 24px; width: 24px"
            >
              <path stroke-linecap="round" stroke-linejoin="round" d="M6 18L18 6M6 6l12 12" />
            </svg>
          </button>
        </div>
        <div class="body modal-body-min">
          <div class="progress-bar">
            <div
              class="bar-inner"
              :class="{ 'reset-bar': isReset }"
              :style="{ width: isReset ? '0%' : ((10 - seconds) / 10) * 100 + '%' }"
            ></div>
          </div>
          <p v-if="redirectedCountry" class="subheader">
            {{
              isWebsiteMukellef
                ? $t('redirectModal.mukellefToConnect.subheaderText')
                : $t('redirectModal.workhyToMukellef.subheaderText')
            }}
          </p>
          <p class="body-text">
            <span v-if="redirectedCountry">
              {{
                isWebsiteMukellef
                  ? $t('redirectModal.mukellefToConnect.descriptionText')
                  : $t('redirectModal.workhyToMukellef.descriptionText')
              }}
            </span>
            <span v-else>{{
              $t('defaultDescription', {
                seconds: seconds,
                website: isWebsiteMukellef ? 'Workhy.com' : 'Mukellef.com',
              })
            }}</span>
          </p>
        </div>
        <div class="footer">
          <button type="button" class="btn btn-close" data-dismiss="modal">{{ $t('Vazgeç') }}</button>
          <button type="button" class="btn btn-redirect" data-dismiss="modal" @click="redirect">
            {{ $t('redirectModal.redirectButtonText', { website: isWebsiteMukellef ? 'Workhy' : 'Mükellef' }) }}
          </button>
        </div>
      </div>
      <!-- /.modal-content -->
    </div>
    <!-- /.modal-dialog -->
    <a id="redirectModal" href="#" data-toggle="modal" data-target="#redirect-modal"></a>
  </div>
  <!-- /.modal -->
</template>
<script>
export default {
  name: 'RedirectModal',
  props: {
    path: {
      type: String,
      default: '',
    },
    redirectedCountry: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      seconds: 10,
      timer: null,
      isReset: true,
    };
  },
  methods: {
    startTimer() {
      this.seconds = 10;
      this.timer = setInterval(() => {
        if (this.seconds > 0) {
          this.seconds--;
        } else {
          this.redirect();
        }
      }, 1000);
    },
    stopTimer() {
      if (this.timer) {
        clearInterval(this.timer);
        this.timer = null;
      }
    },
    redirect() {
      this.stopTimer();
      let refSuffix = '';
      if ($cookies.isKey('affiliate_ref')) {
        refSuffix = '?ref=' + $cookies.get('affiliate_ref');
      }
      const redirectDomain = this.isWebsiteMukellef
        ? process.env.VUE_APP_WORKHY_REGISTER_URI
        : process.env.VUE_APP_MUKELLEF_REGISTER_URI;

      document.location.href = redirectDomain + this.path + refSuffix;
    },
  },
  mounted() {
    const modal = $('#redirect-modal');
    modal.on('show.bs.modal', () => {
      this.isReset = false;
      this.startTimer();
    });
    modal.on('hide.bs.modal', () => {
      this.isReset = true;
      this.stopTimer();
      this.$emit('modal-closed');
    });
  },
  beforeDestroy() {
    const modal = $('#redirect-modal');
    modal.off('show.bs.modal', this.startTimer);
    modal.off('hide.bs.modal', this.stopTimer);
  },
};
</script>
<style scoped lang="less">
.modal-lg {
  @media screen and (min-width: 992px) {
    max-width: 800px;
  }
}
.modal-content {
  row-gap: 8px;
  @media screen and (min-width: 768px) {
    row-gap: 24px;
  }
  .header {
    display: flex;
    justify-content: space-between;
    align-items: center;
    .close-button {
      border: 1px solid #dddddd;
      border-radius: 8px;
      padding: 8px 10px;
    }
    .header-main {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      column-gap: 5px;
      row-gap: 8px;
      @media screen and (min-width: 768px) {
        flex-direction: row;
      }
      .header-text {
        color: #01001a;
        font-size: 20px;
        font-weight: 500;
        line-height: 24px;
        letter-spacing: -0.7px;
        margin: 0;
      }
    }
  }
  .body {
    padding: 16px 8px;
    border: 1px solid #f3f3f3;
    border-radius: 8px;

    @media screen and (min-width: 768px) {
      padding-right: 16px;
      padding-left: 16px;
    }
    .progress-bar {
      background-color: rgba(201, 201, 201, 0.5);
      width: 100%;
      border-radius: 99999px;
      height: 8px;
      margin-bottom: 8px;

      .bar-inner {
        transition: width 1s linear;
        width: 0;
        background-color: #00aa6b;
        height: 100%;
        border-radius: 99999px;

        &.reset-bar {
          transition: none;
        }
      }
    }

    .subheader {
      color: #000;
      margin-bottom: 8px;
      font-size: 16px;
      font-weight: 500;
      line-height: 24px;
      letter-spacing: -0.7px;
      @media screen and (min-width: 768px) {
        margin-bottom: 4px;
      }
    }
    .body-text {
      color: #727272;
      font-size: 14px;
      font-weight: 400;
      line-height: 24px;
      letter-spacing: -0.7px;
      margin: 0;
    }
  }

  .footer {
    display: flex;
    justify-content: flex-end;
    gap: 12px;

    .btn {
      padding: 8px 16px;
      font-size: 14px;
      letter-spacing: -0.48px;
      border-radius: 8px;

      &.btn-close {
        background-color: #fff;
        border: 1px solid #dddddd;
        line-height: 20px;
        letter-spacing: -0.14px;
      }
      &.btn-redirect {
        background-color: #00aa6b;
        color: #fff;
        line-height: 24px;
        font-weight: 500;
        @media screen and (min-width: 768px) {
          font-size: 16px;
        }
      }
    }
  }
}
</style>
